import {React,useRef,useState,useEffect} from "react";
import { useSelector,useDispatch } from "react-redux";
import { updateCustomer } from './../../ReduxActions/customerAction';
import { toast } from 'react-toastify';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import ReactLoading from 'react-loading';
// import { loadCaptchaEnginge, LoadCanvasTemplateNoReload,validateCaptcha } from 'react-simple-captcha';
import { changeNumbers,changeNumbersToEnglish } from "../Common/regex";
import {useHistory } from 'react-router-dom'
import './FillInfo.scss'
import { postData,getData } from "../Services/APIService";
import config from "../Services/config.json";

const FillInfo= () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const customer = useSelector(state => state.customer);

    const txtName = useRef();
    const txtFamily=useRef();
    const txtMelli=useRef();
    const txtMobile=useRef();
    const txtPhone=useRef();
    const txtEmail=useRef();
    const txtPresenter=useRef();
    const txtZip=useRef();
    const txtAddress=useRef();
    const txtSecurityCode=useRef();
    const txtCompanyName=useRef();

    const cmbYear=useRef();
    const cmbMonth=useRef();
    const cmbDay=useRef();
    const cmbSex=useRef();
    const cmbCity=useRef();
    const cmbRegion=useRef();
    const cmbKnow=useRef();

    const txtVerifyCode=useRef();
    const txtVerifyCode1=useRef();
    const txtVerifyCode2=useRef();
    const txtVerifyCode3=useRef();
    const txtVerifyCode4=useRef();

    const [showPopup,setShowPopup] = useState(false);
    const [getLoading,setLoading] = useState(false);

    const [getCities,setCities] = useState([]);
    const [getRegions,setRegions] = useState([]);

    useEffect( () => {
       if(customer.serviceType==1 && customer.serviceCode==0){
            history.push("/");
            return;
       }

        window.scrollTo(0, 0)
        // loadCaptchaEnginge(6,'white','black','lower');
        dispatch(updateCustomer({SecurityCodeDone:1}));

        loadRegions();
        loadCities();
   },[]);

   useEffect( () => {
        console.log("StoreLog: ","Region Changed");
        loadCities();
    },[customer.Region]);


   const loadRegions = async () =>{
        const info={
            token: config.APIKey,
            myLink:''
        };
        try{
            const {data}=await getData('login/Regions',info);

            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                console.log("StoreLog: ","خطایی رخ داده است");
            }
            else{
                setRegions(data.regions);
                dispatch(updateCustomer({Region:data.regions[0].code}));
            }
        }
        catch(ex){
            console.log("StoreLog: ",ex.Message);
        }
   }
   
   const loadCities = async () =>{
        // dispatch(updateCustomer({City:'0'}));
        console.log("StoreLog: ","Load cities");
        const info={
            token: config.APIKey,
            region: customer.Region
        };
        try{
            const {data}=await getData('login/Cities',info);
    
            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                console.log("StoreLog: ","خطایی رخ داده است");
            }
            else{
                setCities(data.cities);
            }
        }
        catch(ex){
            console.log("StoreLog: ",ex.Message);
        }
   }

    const handleItemsChange = async (e) => {
        //e.preventDefault();

        try{dispatch(updateCustomer({Name:txtName.current.value}));}catch{}
        try{dispatch(updateCustomer({Family:txtFamily.current.value}));}catch{}
        try{dispatch(updateCustomer({Melli:txtMelli.current.value}));}catch{}
        try{if(customer.Mobile != txtMobile.current.value){dispatch(updateCustomer({MobileVerified:0}));}}catch{}
        try{dispatch(updateCustomer({Mobile:txtMobile.current.value}));}catch{}
        try{dispatch(updateCustomer({Phone:txtPhone.current.value}));}catch{}
        try{dispatch(updateCustomer({Email:txtEmail.current.value}));}catch{}
        try{dispatch(updateCustomer({Presenter:txtPresenter.current.value}));}catch{}
        try{dispatch(updateCustomer({ZipCode:txtZip.current.value}));}catch{}
        try{dispatch(updateCustomer({Address:txtAddress.current.value}));}catch{}
        try{dispatch(updateCustomer({Year:cmbYear.current.value}));}catch{}
        try{dispatch(updateCustomer({Month:cmbMonth.current.value}));}catch{}
        try{dispatch(updateCustomer({Day:cmbDay.current.value}));}catch{}
        try{if(customer.Real===1) dispatch(updateCustomer({Sex:cmbSex.current.value}));}catch{}
        try{dispatch(updateCustomer({City:cmbCity.current.value}));}catch{}
        try{dispatch(updateCustomer({Region:cmbRegion.current.value}));}catch{}
        try{dispatch(updateCustomer({Know:cmbKnow.current.value}));}catch{}
        try{if(customer.Real!=1){dispatch(updateCustomer({CompanyName:txtCompanyName.current.value}));}}catch{}

        if(
            txtName.current.value && txtName.current.value != '' &&
            txtFamily.current.value && txtFamily.current.value != '' &&
            // txtMelli.current.value && txtMelli.current.value != '' &&
            txtMobile.current.value && txtMobile.current.value != '' &&
            // txtPhone.current.value && txtPhone.current.value != '' &&
            // txtAddress.current.value && txtAddress.current.value != '' &&
            // cmbYear.current.value && cmbYear.current.value != '0' &&
            // cmbMonth.current.value && cmbMonth.current.value != '0' &&
            // cmbDay.current.value && cmbDay.current.value != '0' &&
            // cmbKnow.current.value && cmbKnow.current.value != '0' &&
            (customer.Real === 1 || (txtCompanyName.current.value && txtCompanyName.current.value != '0')) 
            //&&(customer.Real !=1 || (cmbSex.current.value && cmbSex.current.value != '0'))
        ){
            dispatch(updateCustomer({FillInfo:1}));
        }
        else{
            dispatch(updateCustomer({FillInfo:0}));
        }

        // if(txtSecurityCode.current.value.length===6){
        //     if (validateCaptcha(txtSecurityCode.current.value)==true){
        //         dispatch(updateCustomer({SecurityCodeDone:1}));
        //     }
        // }
    };

    const handleSendingCode = async ()=>{

        var mobile=changeNumbersToEnglish(txtMobile.current.value);
        
        if(mobile.startsWith('0')){
            mobile=mobile.substring(1, mobile.length);
            txtMobile.current.value=mobile;
            dispatch(updateCustomer({Mobile:mobile}));
        }

        if(mobile.length!=10){
            toast.error("شماره موبایل باید ده رقمی بدون صفر اول باشد",{
                position:'bottom-left',
                closeButton:true,
                closeOnClick:true
            });
        }
        else{
            setLoading(true);
            const info={
                token: config.APIKey,
                mobile:mobile
             };
    
            try{
                // const {data}=await postData('store/verifyMobilePost',info);
                const {data}=await getData('store/verifyMobile',info);
                
                if (data.Result !== 4 && data.Message!== null) {
                    toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
                    if(data.Message==="کد تایید ارسال شده است"){
                        setShowPopup(true);
                    }
                }
                else if (data.Result !== 4) {
                    toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true});
                }
                else{
                    dispatch(updateCustomer({VerifyCode:data.verifyCode}));
                    setShowPopup(true);
                }
            }
            catch(ex){
                console.log("StoreLog: ",ex.Message);
            }
            setLoading(false);
        }
    }

    const checkForVerify=(num)=>{

        if(num==0){
            if(txtVerifyCode.current.value!=''){
                var code=txtVerifyCode.current.value;
                code=changeNumbersToEnglish(code);
                if(code == customer.VerifyCode){
                    handleVerifiying(code);
                }
            }
            return;
        }

        if(num===1 && txtVerifyCode4.current.value!=''){
            txtVerifyCode3.current.focus()
        }
        else  if(num===2 && txtVerifyCode3.current.value!=''){
            txtVerifyCode2.current.focus()
        }
        else  if(num===3 && txtVerifyCode2.current.value!=''){
            txtVerifyCode1.current.focus()
        }
        else if(num===4 && txtVerifyCode1.current.value!=''){
            var code=txtVerifyCode4.current.value+txtVerifyCode3.current.value+txtVerifyCode2.current.value+txtVerifyCode1.current.value;
            code=changeNumbersToEnglish(code);
            if(code != customer.VerifyCode){
                txtVerifyCode4.current.focus();
            }
            else{
                handleVerifiying(code);
            }
        }
    }

    const handleVerifiying=(code)=>{
        if(code != customer.VerifyCode){
            toast.error("کد تایید صحیح نیست",{
                position:'bottom-left',
                closeButton:true,
                closeOnClick:true
            });
        }
        else{
            setShowPopup(false);
            dispatch(updateCustomer({MobileVerified:1}));
        }
    }

    const handleReal = (real) =>{
        dispatch(updateCustomer({Real:real}));

        if(customer.CustomerCode && customer.CustomerCode!=0){
            dispatch(updateCustomer({
                FillInfo:0,
                Name:'',
                Family:'',
                Melli:'',
                Mobile:'',
                //Phone:'',
                //PrePhone:'021',
                //PhonePure:'',
                ZipCode:'',
                Address:'',
                Year:'0',
                Month:'0',
                Day:'0',
                Sex:'1',
                City:'0',
                Region:'0',
                Know:'0',
                CustomerCode:0,
                FactorCode:0,
            }));
        }
    }

    return (
        <div className="fillInfo">
            <Modal classNames={{closeIcon:"modalClose",modal:"modal"}} open={showPopup} onClose={() => setShowPopup(false)} center>
                <label className="modalTitle">تاییدیه پیامکی</label>
                <div className="modalBody">
                    <label className="modalLabel">کد فعال سازی برای شماره {changeNumbers(customer.Mobile)} پیامک شد</label>
                    <div className="modalDivInput">
                        {/* <input tabIndex="1000" onChange={()=> checkForVerify(1) } className={`verifyCodeInput ${ customer.serviceType === 1 ? "verifyCodeInputADSL" : (customer.serviceType === 2 ? "verifyCodeInputLTE" : "verifyCodeInputGaming")}`} ref={txtVerifyCode4} type="text" inputMode='numeric' placeholder="-"></input>
                        <input tabIndex="1001" onChange={()=> checkForVerify(2) } className={`verifyCodeInput ${ customer.serviceType === 1 ? "verifyCodeInputADSL" : (customer.serviceType === 2 ? "verifyCodeInputLTE" : "verifyCodeInputGaming")}`} ref={txtVerifyCode3} type="text" inputMode='numeric' placeholder="-"></input>
                        <input tabIndex="1002" onChange={()=> checkForVerify(3) } className={`verifyCodeInput ${ customer.serviceType === 1 ? "verifyCodeInputADSL" : (customer.serviceType === 2 ? "verifyCodeInputLTE" : "verifyCodeInputGaming")}`} ref={txtVerifyCode2} type="text" inputMode='numeric' placeholder="-"></input>
                        <input tabIndex="1003" onChange={()=> checkForVerify(4) } className={`verifyCodeInput ${ customer.serviceType === 1 ? "verifyCodeInputADSL" : (customer.serviceType === 2 ? "verifyCodeInputLTE" : "verifyCodeInputGaming")}`} ref={txtVerifyCode1} type="text" inputMode='numeric' placeholder="-"></input>   */}

                        <input tabIndex="1000" onChange={()=> checkForVerify(0) } className={`verifyCodeInput ${ customer.serviceType === 1 ? "verifyCodeInputADSL" : (customer.serviceType === 2 ? "verifyCodeInputLTE" : "verifyCodeInputGaming")}`} ref={txtVerifyCode} type="number" inputMode='numeric' placeholder="----"  textContentType="oneTimeCode"></input>  
                    </div>
                    <div className={`btnVerify ${ customer.serviceType === 1 ? "backADSL" : (customer.serviceType === 2 ? "backLTE" : "backGaming")}`} onClick={handleVerifiying}>تایید</div>
                </div>
            </Modal>
            <div className="divRealLegal">
                <div className="titlePage">
                    <span className="fa fa-wpforms"></span>
                    <label>تکمیل اطلاعات :</label>
                </div>
                <div className="divReal">
                    <div className={`divRealI ${ customer.Real === 1 ? "divRealISelect" : "" }`} onClick={()=> handleReal(1)}>حقیقی</div>
                    <div className={`divRealI ${ customer.Real === 2 ? "divRealISelect" : "" }`} onClick={()=> handleReal(2)}>حقوقی</div>
                </div>
                <div className="titlePage"></div>
            </div>
            {
                customer.Real === 2 ?
                <div className="rndBoxP">
                    <div className="rndBox">
                        <input ref={txtCompanyName} type="text" className="txtFiled" value={customer.CompanyName} placeholder="نام شرکت را وارد کنید" onChange={handleItemsChange}></input>
                        <label className="rndBoxLabel"><label className="rndBoxLabelStar">*</label>نام شرکت</label>
                        <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-briefcase"></div></div>
                    </div>
                </div>
                :
                null
            }
            <div className="rndBoxP"><div className="rndBox">
                <input ref={txtName} type="text" className="txtFiled" value={customer.Name} placeholder="نام را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel"><label className="rndBoxLabelStar">*</label>{customer.Real === 1 ? "نام" : "نام مدیرعامل"}</label>
                <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-user-o"></div></div>
            </div></div>
            <div className="rndBoxP"><div className="rndBox">
                <input ref={txtFamily} type="text" className="txtFiled" value={customer.Family} placeholder="نام خانوادگی را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel"><label className="rndBoxLabelStar">*</label>{customer.Real === 1 ? "نام خانوادگی" : "نام خانوادگی مدیرعامل"}</label>
                <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-user-o"></div></div>
            </div></div>
            {customer.Real === 1 &&
                <div className="rndBoxP"><div className="rndBox">
                    <input ref={txtMelli} type="text" className="txtFiled txtFiledLeft" type="number" value={customer.Melli} placeholder={customer.Real === 1 ? "کد ملی را وارد کنید" : "شناسه ملی را وارد کنید"} onChange={handleItemsChange}></input>
                    <label className="rndBoxLabel">{customer.Real === 1 ? "کد ملی" : "شناسه ملی"}</label>
                    <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-address-card"></div></div>
                </div></div>
            }
            <div className="rndBoxP"><div className="rndBox">
                <div className={`btnSendCode ${ customer.serviceType === 1 ? "backADSL" : (customer.serviceType === 2 ? "backLTE" : "backGaming")} ${customer.MobileVerified===1? " backGreen disabled":""}`} onClick={handleSendingCode}>
                    <span>
                    {
                        !getLoading ? (customer.MobileVerified!=1 ? "ارسال کد تایید" : "تایید شده") :
                        <ReactLoading type="bubbles" color={"#ff8035"} />
                    }
                    </span>
                </div>
                <input ref={txtMobile} className="txtFiled txtFiledLeft" value={customer.Mobile} placeholder="تلفن همراه را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel"><label className="rndBoxLabelStar">*</label>تلفن همراه</label>
                <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-mobile"></div></div>
            </div></div>
            { customer.serviceType != 2 && <div className="rndBoxP"><div className="rndBox">
                <input ref={txtPhone} type="text" className="txtFiled txtFiledLeft" value={customer.Phone} placeholder="تلفن ثابت با پیش شماره استان را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel">تلفن ثابت</label>
                <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-phone"></div></div>
            </div></div>}
            {/* {customer.Real === 2 &&
            <div className="rndBoxP"><div className="rndBox">
                <input ref={txtEmail} type="text" className="txtFiled txtFiledLeft" value={customer.Email} placeholder="ایمیل را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel"> ایمیل</label>
                <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-envelope"></div></div>
            </div></div>
            } */}
            {/* {customer.Real === 2 &&
            <div className="rndBoxP"><div className="rndBox">
                <select ref={cmbYear} value={customer.Year} className="rndBoxCmb rndBoxCmbSmall" onChange={handleItemsChange}>
                    <option value="0">سال</option>
                    <option value="1300">1300</option>
                    <option value="1301">1301</option>
                    <option value="1302">1302</option>
                    <option value="1303">1303</option>
                    <option value="1304">1304</option>
                    <option value="1305">1305</option>
                    <option value="1306">1306</option>
                    <option value="1307">1307</option>
                    <option value="1308">1308</option>
                    <option value="1309">1309</option>
                    <option value="1310">1310</option>
                    <option value="1311">1311</option>
                    <option value="1312">1312</option>
                    <option value="1313">1313</option>
                    <option value="1314">1314</option>
                    <option value="1315">1315</option>
                    <option value="1316">1316</option>
                    <option value="1317">1317</option>
                    <option value="1318">1318</option>
                    <option value="1319">1319</option>
                    <option value="1320">1320</option>
                    <option value="1321">1321</option>
                    <option value="1322">1322</option>
                    <option value="1323">1323</option>
                    <option value="1324">1324</option>
                    <option value="1325">1325</option>
                    <option value="1326">1326</option>
                    <option value="1327">1327</option>
                    <option value="1328">1328</option>
                    <option value="1329">1329</option>
                    <option value="1330">1330</option>
                    <option value="1331">1331</option>
                    <option value="1332">1332</option>
                    <option value="1333">1333</option>
                    <option value="1334">1334</option>
                    <option value="1335">1335</option>
                    <option value="1336">1336</option>
                    <option value="1337">1337</option>
                    <option value="1338">1338</option>
                    <option value="1339">1339</option>
                    <option value="1340">1340</option>
                    <option value="1341">1341</option>
                    <option value="1342">1342</option>
                    <option value="1343">1343</option>
                    <option value="1344">1344</option>
                    <option value="1345">1345</option>
                    <option value="1346">1346</option>
                    <option value="1347">1347</option>
                    <option value="1348">1348</option>
                    <option value="1349">1349</option>
                    <option value="1350">1350</option>
                    <option value="1351">1351</option>
                    <option value="1352">1352</option>
                    <option value="1353">1353</option>
                    <option value="1354">1354</option>
                    <option value="1355">1355</option>
                    <option value="1356">1356</option>
                    <option value="1357">1357</option>
                    <option value="1358">1358</option>
                    <option value="1359">1359</option>
                    <option value="1360">1360</option>
                    <option value="1361">1361</option>
                    <option value="1362">1362</option>
                    <option value="1363">1363</option>
                    <option value="1364">1364</option>
                    <option value="1365">1365</option>
                    <option value="1366">1366</option>
                    <option value="1367">1367</option>
                    <option value="1368">1368</option>
                    <option value="1369">1369</option>
                    <option value="1370">1370</option>
                    <option value="1371">1371</option>
                    <option value="1372">1372</option>
                    <option value="1373">1373</option>
                    <option value="1374">1374</option>
                    <option value="1375">1375</option>
                    <option value="1376">1376</option>
                    <option value="1377">1377</option>
                    <option value="1378">1378</option>
                    <option value="1379">1379</option>
                    <option value="1380">1380</option>
                    <option value="1381">1381</option>
                    <option value="1382">1382</option>
                    <option value="1383">1383</option>
                    <option value="1384">1384</option>
                    <option value="1385">1385</option>
                    <option value="1386">1386</option>
                    <option value="1387">1387</option>
                    <option value="1388">1388</option>
                    <option value="1389">1389</option>
                    <option value="1390">1390</option>
                    <option value="1391">1391</option>
                    <option value="1392">1392</option>
                    <option value="1393">1393</option>
                    <option value="1394">1394</option>
                    <option value="1395">1395</option>
                    <option value="1396">1396</option>
                    <option value="1397">1397</option>
                    <option value="1398">1398</option>
                    <option value="1399">1399</option>
                    <option value="1400">1400</option>
                </select>
                <span className="borderVer"></span>
                <select ref={cmbMonth} value={customer.Month} className="rndBoxCmb rndBoxCmbSmall" onChange={handleItemsChange}>
                    <option value="0">ماه</option>
                    <option value="1">فروردین</option>
                    <option value="2">اردیبهشت</option>
                    <option value="3">خرداد</option>
                    <option value="4">تیر</option>
                    <option value="5">مرداد</option>
                    <option value="6">شهریور</option>
                    <option value="7">مهر</option>
                    <option value="8">آبان</option>
                    <option value="9">آذر</option>
                    <option value="10">دی</option>
                    <option value="11">بهمن</option>
                    <option value="12">اسفند</option>
                </select>
                <span className="borderVer"></span>
                <select ref={cmbDay} value={customer.Day} className="rndBoxCmb rndBoxCmbSmall" onChange={handleItemsChange}>
                    <option value="0">روز</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                </select>
                <label className="rndBoxLabel">{customer.Real === 1 ? "تاریخ تولد" : "تاریخ ثبت شرکت"}</label>
                <div className="rndBoxIcon">
                    <div className="rndBoxIcon2 fa fa-calendar"></div>
                </div>
            </div></div>
            } */}
            {/* {customer.Real === 1 &&
            <div className="rndBoxP"><div className="rndBox">
                <div className="rndBoxContainer">
                    <select ref={cmbSex} value={customer.Sex} className="rndBoxCmb" onChange={handleItemsChange}>
                        <option value="1">مرد</option>
                        <option value="2">زن</option>
                    </select>
                </div>
                <label className="rndBoxLabel">جنسیت</label>
                <div className="rndBoxIcon">
                    <div className="rndBoxIcon2 fa fa-user-o"></div>
                </div>
            </div></div>
            } */}
            {/* {customer.Real === 2 &&
            <div className="rndBoxP"><div className="rndBox">
                <input ref={txtZip} type="text" className="txtFiled txtFiledLeft" type="number" value={customer.ZipCode} placeholder="کد پستی را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel">کد پستی</label>
                <div className="rndBoxIcon">
                    <div className="rndBoxIcon2 fa fa-address-card-o"></div>
                </div>
            </div></div>
            } */}
            <div className="rndBoxP"><div className="rndBox">
                <div className="rndBoxContainer">
                    <select ref={cmbRegion} value={customer.Region} className="rndBoxCmb" onChange={handleItemsChange}>
                        {
                             getRegions.map(item => (
                                <option value={item.code}>{item.name}</option>
                            ))
                        }
                    </select>
                </div>
                <label className="rndBoxLabel">استان</label>
                <div className="rndBoxIcon">
                    <div className="rndBoxIcon2 fa fa-map-marker"></div>
                </div>
            </div></div>
            <div className="rndBoxP"><div className="rndBox">
                <div className="rndBoxContainer">
                    <select ref={cmbCity} value={customer.City} className="rndBoxCmb" onChange={handleItemsChange}>
                        <option value="0">انتخاب</option>
                        {
                             getCities.map(item => (
                                <option value={item.code}>{item.name}</option>
                            ))
                        }
                    </select>
                </div>
                <label className="rndBoxLabel"><label className="rndBoxLabelStar">*</label>شهر</label>
                <div className="rndBoxIcon">
                    <div className="rndBoxIcon2 fa fa-map-marker"></div>
                </div>
            </div></div>
            <div className="rndBoxP"><div className="rndBox">
                <div className="rndBoxContainer">
                    <select ref={cmbKnow} value={customer.Know} className="rndBoxCmb" onChange={handleItemsChange}>
                        <option value="0">انتخاب</option>
                        <option value="2">جستجو در گوگل</option>
                        <option value="3">پیامک های تبلیغاتی</option>
                        <option value="4">آپارات</option>
                        <option value="1">معرفی دوستان و آشنایان</option>
                        <option value="6">بیلبورد</option>
                        <option value="9">شبکه های اجتماعی</option>
                    </select>
                </div>
                <label className="rndBoxLabel">نحوه آشنایی</label>
                <div className="rndBoxIcon">
                    <div className="rndBoxIcon2 fa fa-google"></div>
                </div>
            </div></div>
           
            <div className="rndBoxP"><div className="rndBox">
                {/* <input ref={txtSecurityCode} type="text" className="txtFiled txtFiledLeft txtSmall" placeholder="کد روبرو را وارد کنید" onChange={handleItemsChange}></input>
                <div className="divCaptcha" onClick={()=>loadCaptchaEnginge(6,'white','black','lower')}>
                    <LoadCanvasTemplateNoReload />
                </div>
                <label className="rndBoxLabel">کد امنیتی</label> */}
                <input ref={txtPresenter} type="text" className="txtFiled txtFiledLeft" value={customer.Presenter} placeholder="نام کاربری معرف را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel"> نام کاربری معرف</label>
                <div className="rndBoxIcon"><div className="rndBoxIcon2 fa fa-star"></div></div>
            </div></div>
            <div className="rndBoxP2"><div className="rndBox">
                <input ref={txtAddress} type="text" className="txtFiled" value={customer.Address} placeholder="آدرس را وارد کنید" onChange={handleItemsChange}></input>
                <label className="rndBoxLabel">آدرس </label>
            </div></div>
           
        </div>
    );
}
export default FillInfo;